// extracted by mini-css-extract-plugin
export default {"message_box":"MessageBoxSimple_message_box__G2NiZ","message":"MessageBoxSimple_message__jtNn0"};